import axios, {
    AxiosRequestConfig,
    AxiosResponse
} from 'axios';
import { get } from 'lodash';
import ConfigurationValuesService, { IConfigurationValuesService } from './ConfigurationValuesService';

export interface IHttpService {
    /**
     * @deprecated Use post while annotating the endpoint method with the @RequireGuestToken decorator
     */
    postWithGuestAuthorisation<Response = any, RequestBody = any>(url: string, data?: RequestBody, additionalHeaders?: any): Promise<AxiosResponse<Response>>;
    post<Response = any, RequestBody = any>(url: string, data?: RequestBody, additionalConfig?: Partial<AxiosRequestConfig>): Promise<AxiosResponse<Response>>;
    get<T = any>(url: string, additionalConfig?: Partial<AxiosRequestConfig>): Promise<AxiosResponse<T>>;
}

export default class HttpService implements IHttpService {
    readonly configurationValuesService: IConfigurationValuesService;

    constructor() {
        this.configurationValuesService = ConfigurationValuesService.getInstance();
    }

    async post<Response = any, RequestBody = any>(
        url: string,
        data?: RequestBody,
        additionalConfig?: Partial<AxiosRequestConfig>
    ): Promise<AxiosResponse<Response>> {
        return axios.post<Response>(
            url,
            data ?? {},
            {
                ...(additionalConfig ?? {})
            }
        );
    }

    /**
     * @deprecated Use post while annotating the endpoint method with the @RequireGuestToken decorator
     */
    async postWithGuestAuthorisation<
        Response = any,
        RequestBody = any
    >(
        url: string,
        data?: RequestBody,
        additionalHeaders?: any
    ): Promise<AxiosResponse<Response>> {
        const guestTokenObject = await this.getGuestToken();
        const guestToken = get(guestTokenObject, 'data.token');
        const Authorization = `Bearer ${guestToken}`;

        return axios.post<Response>(
            url,
            data ?? {},
            {
                headers: {
                    Authorization,
                    ...additionalHeaders
                }
            }
        );
    }

    async get<T = any>(url: string, additionalConfig: Partial<AxiosRequestConfig> = {}): Promise<AxiosResponse<T>> {
        return await axios.get<T>(url, {
            ...additionalConfig
        });
    }

    async getGuestToken() {
        const url = `${this.configurationValuesService.apiUrl}/sessions/guest`;
        return await this.get(url);
    }
}



// WEBPACK FOOTER //
// ./src/services/HttpService.ts